import axios from 'axios';
import store from './store';

const instance = axios.create({
  baseURL: `/motiverse/api`
});

instance.interceptors.request.use(
  config => {
    const token = store.getters.token;
    if (token) {
      config.headers.authorization = `Basic ${token}`;
    }
    const customShareAuthToken = store.getters.customShareAuthToken;
    if (customShareAuthToken) {
        config.headers['X-Share-Auth'] = customShareAuthToken;
    }
    return config;
  },
  error => Promise.reject(error)
);

export default instance;
